// ---------------------------------------------- modules import
import { PinnedPostAction, PinnedPostActionType } from "./common";

// ---------------------------------------------- action creators
class Actions {
  static updateBegin = (): PinnedPostAction => ({
    type: PinnedPostActionType.UPDATE_PINNEDPOST_BEGIN
  });

  static updateSuccess = (): PinnedPostAction => ({
    type: PinnedPostActionType.UPDATE_PINNEDPOST_SUCCESS
  });

  static updateError = (error: string): PinnedPostAction => ({
    type: PinnedPostActionType.UPDATE_PINNEDPOST_ERROR,
    payload: {
      error
    }
  });

  static unpinBegin = (): PinnedPostAction => ({
    type: PinnedPostActionType.UNPIN_PINNEDPOST_BEGIN
  });

  static unpinSuccess = (): PinnedPostAction => ({
    type: PinnedPostActionType.UNPIN_PINNEDPOST_SUCCESS
  });

  static unpinError = (error: string): PinnedPostAction => ({
    type: PinnedPostActionType.UNPIN_PINNEDPOST_ERROR,
    payload: {
      error
    }
  });
}

export default Actions;
